export default function CompleteIcon() {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.2509 46.875H18.7509M41.2509 46.875C43.2401 46.875 45.1477 47.6652 46.5542 49.0717C47.9608 50.4782 48.7509 52.3859 48.7509 54.375H11.2509C11.2509 52.3859 12.0411 50.4782 13.4476 49.0717C14.8542 47.6652 16.7618 46.875 18.7509 46.875M41.2509 46.875V38.4375C41.2509 36.885 39.9934 35.625 38.4384 35.625H36.2609M18.7509 46.875V38.4375C18.7509 36.885 20.0109 35.625 21.5634 35.625H23.7434M36.2609 35.625H23.7434M36.2609 35.625C34.8568 33.1999 34.0176 30.4893 33.8059 27.695M23.7434 35.625C25.1467 33.1997 25.985 30.4891 26.1959 27.695M33.8059 27.695C36.3258 27.1135 38.6751 25.9585 40.6759 24.32M33.8059 27.695C31.3021 28.2725 28.6997 28.2725 26.1959 27.695M26.1959 27.695C23.6769 27.1131 21.326 25.9582 19.3259 24.32M13.1259 10.59C10.6709 10.9475 8.24094 11.3825 5.83594 11.89C6.39343 15.162 8.01988 18.1568 10.4608 20.4059C12.9017 22.6551 16.0194 24.0315 19.3259 24.32M13.1259 10.59V11.25C13.1259 16.52 15.5409 21.225 19.3259 24.32M13.1259 10.59V6.8025C18.6409 6.025 24.2759 5.625 30.0009 5.625C35.7284 5.625 41.3634 6.025 46.8759 6.8V10.59M46.8759 10.59V11.25C46.8759 16.52 44.4609 21.225 40.6759 24.32M46.8759 10.59C49.3192 10.9455 51.7504 11.3791 54.1659 11.89C53.6086 15.1616 51.9825 18.1561 49.5421 20.4052C47.1016 22.6543 43.9821 24.031 40.6759 24.32"
        stroke="#207E7D"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
